import moment from 'moment'
import React from 'react'
import { FormInput } from '../../../../../onestep-library/BaseUI'

function Scheduler(props){
  const { isInvoice, stepNumber, starts_at, ends_at, interval_count, interval, end_type, occurrences, 
          handleChange, hasNumbers=true, isIndented=true, showScheduleDate=true, first_due_date, disabled, useBoldLabels } = props

  const intervalTypes = [
    {
      label: 'Day(s)',
      value: 'days'
    },
    {
      label: 'Week(s)',
      value: 'weeks'
    },
    {
      label: 'Month(s)',
      value: 'months'
    },
  ]

  const endTypes = [
    {
      label: 'On Date', 
      value: 'on_date'
    },
    {
      label: 'After Number Of occurrences', 
      value: 'number_of_occurrences'
    },
    {
      label: 'Never',
      value: 'never'
    }
  ]

  function handleSetEndsType(e){
    handleChange({
      end_type: e.value,
      ends_at: undefined,
      occurrences: undefined,
    })
  }

  return(
    <div>
      <div>
      { showScheduleDate &&
        <FormInput 
          disabled={disabled}
          readOnly={true}
          type="date"
          minDate={moment().add(1, 'day')}
          labelClassName={useBoldLabels && "font-weight-bold"}
          label={`${hasNumbers ? `${stepNumber}a. ` : ''} First Due Date`}
          value={first_due_date}
          desc="Note: All recurring charges must start at least 1 day from today. If you need to charge a card same day, please generate a single payment for the charge for today."
          handleChange={(first_due_date)=>handleChange({first_due_date})}
          placeholder={`Enter First Due Date...`}/>
      }
        <FormInput 
          disabled={disabled}
          label={`${hasNumbers ? `${stepNumber}b. ` : ''}Every`} 
          labelClassName={useBoldLabels && "font-weight-bold"}
          type="number"
          handleChange={(interval_count)=>handleChange({interval_count})} 
          value={interval_count} 
          placeholder="Enter Number..." 
          className="mb-3"/>
        <FormInput
          disabled={disabled}
          type="select"
          labelClassName={useBoldLabels && "font-weight-bold"}
          label={`${hasNumbers ? `${stepNumber}c. ` : ''}Interval`}
          handleChange={(e)=>handleChange({interval: e.value})}
          options={intervalTypes}
          value={intervalTypes.find(type => type.value === interval)}
          placeholder="Select Interval..."/>
        <FormInput 
          disabled={disabled}
          type="select"
          labelClassName={useBoldLabels && "font-weight-bold"}
          label={`${hasNumbers ? `${stepNumber}d. ` : ''}Ends`}
          handleChange={(e)=>handleSetEndsType(e)}
          options={endTypes}
          placeholder="On Date Or After Number Of Occurrences?"/>
        { end_type === 'on_date' &&
          <FormInput
            disabled={disabled}
            labelClassName={useBoldLabels && "font-weight-bold"}
            type="date"
            value={ends_at}
            label={`${hasNumbers ? `${stepNumber}e. ` : ''}End Date`}
            handleChange={(ends_at)=>handleChange({ends_at})}
            placeholder="Enter End Date..."/>
        }
        { end_type === 'number_of_occurrences' &&
          <FormInput 
            disabled={disabled}
            labelClassName={useBoldLabels && "font-weight-bold"}
            type="number"
            value={occurrences}
            label={`${hasNumbers ? `${stepNumber}e. ` : ''}Number of occurrences`}
            handleChange={(occurrences)=>handleChange({occurrences})} 
            placeholder="Enter Number Of Occurrences"/>
        }
      </div>
    </div>
  )
}

export default Scheduler
